import { useState } from "react";
import { DisputeAttachment, Question } from "../../ProviderProfile/models";
import './DisputeQuestionAdditionalInfo.scss';
import { InputTextarea } from "primereact/inputtextarea";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ApiEndpoints, Constants } from "../../../constants/appConstants";
import httpService from "../../../services/httpService";

interface DisputeQuestionAdditionalInfoProps {
    question: Question;
}

export default function DisputeQuestionAdditionalInfo({ question }: DisputeQuestionAdditionalInfoProps) {
    // useEffect(()=>{
    //     console.log(question.attachments)
    // },[]);

    const [showDialog,setShowDialog] = useState(false);
     const downloadDataFile = (fileName: string,filePath:string) => {
        httpService
            .post(
                `${ApiEndpoints.DownloadFileByRelativePath}`,{
                relativePath: filePath, fileName }
            ).then((response: any) => {
                    if (response) {
                        //console.log("response", response);
                        let url = response.data.url;
                        const validatedUrl = new URL(url);
                        if (
                            validatedUrl.protocol === "http:" ||
                            validatedUrl.protocol === "https:"
                        ) {
                            const anchor = document.createElement("a");
                            anchor.href = validatedUrl.toString();
                            anchor.target = "_blank";
                            anchor.click();
                        }
                    }
                },
                (error: any) => {
                    console.error("Error downloading file:", error);
                    setShowDialog(true);
                }
            );
    };
    return (
        <div className="dispute-additional-info-container">
            <div className="resolution-header">
                <span><strong>Resolution Reason</strong></span>
            </div>
            <div className="resolution-description">
                <span>
                    Reviewers should evaluate if the below Resolution response successfully addresses the fail reasons assigned to the original response above.
                </span>
            </div>
            <div className="response-section">
                <label>Response</label>
                <InputTextarea
                    className="response-textarea"
                    value={question.comment || ''}
                    readOnly
                    rows={3}
                    style={{ width: '100%', resize: 'none', background: '#e9ecef', borderRadius: 4, border: 'none', marginTop: 4 }}
                />
            </div>
            {Array.isArray(question.attachments) && question.attachments.length > 0 && (
            <div className="additional-upload-section">
                <label>Additional File Upload</label>
                <div className="file-upload-box" style={{ flexDirection: 'column', gap: '8px' }}>
                    {
                        question.attachments.map((file: DisputeAttachment) => (
                            <a
                                key={file.FileSequence}
                                className="file-download-btn"
                                style={{ marginBottom: 4 }}
                                onClick={() => downloadDataFile(file.FileName, file.FilePath)}
                            >
                                <i className="pi pi-download" style={{ marginRight: '8px' }} />
                                {file.FileName}
                            </a>
                        ))
                    }
                </div>
            </div>
            )}
            <Dialog
                    header="File not found!"
                    visible={showDialog}
                    onHide={()=>setShowDialog(false)}
                    footer={
                      <div style={{ display: "flex", justifyContent: "end" }}>
                        <Button
                          label="Close"
                          icon="pi pi-times"
                          className="p-button-secondary"
                          onClick={()=>setShowDialog(false)}
                          autoFocus
                        />
                      </div>
                    }
                  >
                    <div>
                      <p>{Constants.FILE_NOT_FOUND_ERROR}</p>
                    </div>
                  </Dialog>
        </div>

        
    );
}